import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const TAREAS_LABEL = {
  limpieza_hab: "Limpieza habitación",
  lavado_ropa: "Lavado de ropa",
  planchado: "Planchado",
};
const TAREAS_OPCIONES = Object.entries(TAREAS_LABEL);

const VACIO = { emoji: "", titulo: "", tarea: "limpieza_hab" };

const AdminOpcionesNoHecho = () => {
  const navigate = useNavigate();
  const [filas, setFilas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [editando, setEditando] = useState(null); // id | "nuevo" | null
  const [form, setForm] = useState(VACIO);
  const [guardando, setGuardando] = useState(false);
  const [filtraTarea, setFiltraTarea] = useState("todas");

  const cargar = async () => {
    setLoading(true);
    try {
      const res = await axios.get("/api/servicio/opciones_no_hecho");
      setFilas(res.data || []);
      setError("");
    } catch {
      setError("❌ Error al cargar opciones.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { cargar(); }, []);

  const abrirNuevo = () => {
    setForm({ ...VACIO, tarea: filtraTarea !== "todas" ? filtraTarea : "limpieza_hab" });
    setEditando("nuevo");
  };
  const abrirEditar = (fila) => {
    setForm({ emoji: fila.emoji || "", titulo: fila.titulo, tarea: fila.tarea });
    setEditando(fila.id);
  };
  const cancelar = () => { setEditando(null); setForm(VACIO); };

  const guardar = async () => {
    if (!form.titulo.trim()) { setError("El título es obligatorio."); return; }
    if (!form.tarea) { setError("Selecciona una tarea."); return; }
    setGuardando(true);
    setError("");
    try {
      if (editando === "nuevo") {
        await axios.post("/api/servicio/opciones_no_hecho", form);
      } else {
        await axios.put(`/api/servicio/opciones_no_hecho/${editando}`, form);
      }
      await cargar();
      cancelar();
    } catch (e) {
      setError(e.response?.data?.error || "❌ Error al guardar.");
    } finally {
      setGuardando(false);
    }
  };

  const eliminar = async (id) => {
    if (!window.confirm("¿Eliminar esta razón?")) return;
    try {
      await axios.delete(`/api/servicio/opciones_no_hecho/${id}`);
      setFilas((f) => f.filter((r) => r.id !== id));
    } catch {
      setError("❌ Error al eliminar.");
    }
  };

  const filasFiltradas = filtraTarea === "todas" ? filas : filas.filter(f => f.tarea === filtraTarea);

  return (
    <div style={{ minHeight: "100vh", background: "#f0f4f8", padding: "24px 16px" }}>
      <div style={{ maxWidth: 700, margin: "0 auto" }}>
        <button
          onClick={() => navigate(-1)}
          style={{ background: "none", border: "none", cursor: "pointer", fontSize: 15, color: "#3b82f6", fontWeight: 700, marginBottom: 20, padding: 0 }}
        >
          ← Volver
        </button>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 20 }}>
          <h2 style={{ fontSize: 22, fontWeight: 800, color: "#1e3a5f", margin: 0 }}>❌ Razones "No hecho"</h2>
          {editando === null && (
            <button
              onClick={abrirNuevo}
              style={{ background: "#3b82f6", color: "#fff", border: "none", borderRadius: 10, padding: "10px 18px", fontWeight: 700, cursor: "pointer", fontSize: 15 }}
            >
              + Añadir
            </button>
          )}
        </div>

        <div style={{ background: "#fff7ed", border: "1.5px solid #fed7aa", borderRadius: 12, padding: "12px 16px", marginBottom: 20, fontSize: 14, color: "#92400e" }}>
          Cuando la asistenta marca "No hecho" en limpieza, lavado o planchado, debe seleccionar obligatoriamente una de estas razones.
        </div>

        {error && <div style={{ background: "#fee2e2", color: "#b91c1c", borderRadius: 10, padding: "10px 14px", marginBottom: 16 }}>{error}</div>}

        {/* Formulario */}
        {editando !== null && (
          <div style={{ background: "#fff", border: "2px solid #3b82f6", borderRadius: 14, padding: 20, marginBottom: 24, boxShadow: "0 2px 8px rgba(0,0,0,0.08)" }}>
            <div style={{ fontSize: 16, fontWeight: 700, color: "#1e3a5f", marginBottom: 16 }}>
              {editando === "nuevo" ? "Nueva razón" : "Editar razón"}
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
              <div>
                <label style={{ fontSize: 13, fontWeight: 600, color: "#475569", display: "block", marginBottom: 4 }}>Tarea *</label>
                <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                  {TAREAS_OPCIONES.map(([val, label]) => (
                    <button
                      key={val}
                      type="button"
                      onClick={() => setForm(f => ({ ...f, tarea: val }))}
                      style={{
                        padding: "8px 16px", borderRadius: 10, border: "2px solid",
                        borderColor: form.tarea === val ? "#3b82f6" : "#e2e8f0",
                        background: form.tarea === val ? "#eff6ff" : "#f8fafc",
                        color: form.tarea === val ? "#1d4ed8" : "#374151",
                        fontWeight: form.tarea === val ? 700 : 500,
                        cursor: "pointer", fontSize: 14,
                      }}
                    >
                      {label}
                    </button>
                  ))}
                </div>
              </div>
              <div>
                <label style={{ fontSize: 13, fontWeight: 600, color: "#475569", display: "block", marginBottom: 4 }}>Emoji</label>
                <input
                  type="text"
                  value={form.emoji}
                  onChange={(e) => setForm((f) => ({ ...f, emoji: e.target.value }))}
                  placeholder="Ej: 🤒"
                  style={{ width: 80, padding: "10px 12px", borderRadius: 8, border: "1.5px solid #cbd5e1", fontSize: 20, textAlign: "center" }}
                />
              </div>
              <div>
                <label style={{ fontSize: 13, fontWeight: 600, color: "#475569", display: "block", marginBottom: 4 }}>Razón *</label>
                <input
                  type="text"
                  value={form.titulo}
                  onChange={(e) => setForm((f) => ({ ...f, titulo: e.target.value }))}
                  placeholder="Ej: Alumna enferma"
                  style={{ width: "100%", padding: "10px 12px", borderRadius: 8, border: "1.5px solid #cbd5e1", fontSize: 15, boxSizing: "border-box" }}
                />
              </div>
            </div>
            <div style={{ display: "flex", gap: 10, marginTop: 16 }}>
              <button
                onClick={guardar}
                disabled={guardando}
                style={{ background: "#3b82f6", color: "#fff", border: "none", borderRadius: 8, padding: "10px 20px", fontWeight: 700, cursor: "pointer", fontSize: 14 }}
              >
                {guardando ? "Guardando..." : "Guardar"}
              </button>
              <button
                onClick={cancelar}
                style={{ background: "#e2e8f0", color: "#475569", border: "none", borderRadius: 8, padding: "10px 16px", fontWeight: 600, cursor: "pointer", fontSize: 14 }}
              >
                Cancelar
              </button>
            </div>
          </div>
        )}

        {/* Filtro por tarea */}
        <div style={{ display: "flex", gap: 8, marginBottom: 16, flexWrap: "wrap" }}>
          <button
            onClick={() => setFiltraTarea("todas")}
            style={{ padding: "7px 14px", borderRadius: 10, border: "2px solid", borderColor: filtraTarea === "todas" ? "#1e3a5f" : "#e2e8f0", background: filtraTarea === "todas" ? "#1e3a5f" : "#fff", color: filtraTarea === "todas" ? "#fff" : "#374151", fontWeight: 700, cursor: "pointer", fontSize: 13 }}
          >
            Todas
          </button>
          {TAREAS_OPCIONES.map(([val, label]) => (
            <button
              key={val}
              onClick={() => setFiltraTarea(val)}
              style={{ padding: "7px 14px", borderRadius: 10, border: "2px solid", borderColor: filtraTarea === val ? "#3b82f6" : "#e2e8f0", background: filtraTarea === val ? "#eff6ff" : "#fff", color: filtraTarea === val ? "#1d4ed8" : "#374151", fontWeight: filtraTarea === val ? 700 : 500, cursor: "pointer", fontSize: 13 }}
            >
              {label}
            </button>
          ))}
        </div>

        {loading ? (
          <div style={{ textAlign: "center", color: "#64748b", padding: 40 }}>Cargando...</div>
        ) : filasFiltradas.length === 0 ? (
          <div style={{ background: "#fff", borderRadius: 14, padding: 32, textAlign: "center", color: "#94a3b8" }}>
            No hay razones para esta tarea. Pulsa "+ Añadir" para crear la primera.
          </div>
        ) : (
          <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
            {TAREAS_OPCIONES.map(([tarea, tareaLabel]) => {
              const grupo = filasFiltradas.filter(f => f.tarea === tarea);
              if (grupo.length === 0) return null;
              return (
                <div key={tarea}>
                  <div style={{ fontSize: 13, fontWeight: 700, color: "#6b7280", textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: 6, paddingLeft: 4 }}>
                    {tareaLabel}
                  </div>
                  <div style={{ background: "#fff", borderRadius: 14, boxShadow: "0 2px 6px rgba(0,0,0,0.06)", overflow: "hidden" }}>
                    {grupo.map((fila, idx) => (
                      <div
                        key={fila.id}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          padding: "14px 18px",
                          borderBottom: idx < grupo.length - 1 ? "1px solid #f1f5f9" : "none",
                          gap: 14,
                        }}
                      >
                        <span style={{ fontSize: 26, minWidth: 32, textAlign: "center" }}>{fila.emoji || "❌"}</span>
                        <div style={{ flex: 1 }}>
                          <div style={{ fontSize: 15, fontWeight: 700, color: "#1e3a5f" }}>{fila.titulo}</div>
                        </div>
                        <button
                          onClick={() => abrirEditar(fila)}
                          style={{ background: "#eff6ff", border: "1.5px solid #bfdbfe", borderRadius: 8, padding: "7px 14px", cursor: "pointer", color: "#3b82f6", fontWeight: 600, fontSize: 13 }}
                        >
                          ✏️ Editar
                        </button>
                        <button
                          onClick={() => eliminar(fila.id)}
                          style={{ background: "#fff1f2", border: "1.5px solid #fca5a5", borderRadius: 8, padding: "7px 14px", cursor: "pointer", color: "#dc2626", fontWeight: 600, fontSize: 13 }}
                        >
                          🗑 Borrar
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminOpcionesNoHecho;
